/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const populateChallengeIdsBodySchema = z.object({
  collectionSlug: z.string().optional(),
  limit: z.number().min(1).max(5000).default(100),
  backfill: z.boolean().optional().default(false),
  forceFill: z.boolean().optional().default(false),
});

export type IPopulateChallengeIdsBody = z.infer<typeof populateChallengeIdsBodySchema>;
